export const constantBuilder = (constant, placeholders) => {
  Object.entries(placeholders).forEach(([key, value]) => {
    const expr = new RegExp(`__${key}__`, 'g')
    constant = constant.replace(expr, value)
  })
  return constant
}
